export default "__VITE_ASSET__D$37UMeK__"